import { Controller } from 'stimulus'

// Confirmation dialog before the final submit (Page 2 for non-Brand-Owners, Page 3
// for Brand Owners). The server validates first and, when the page is valid but not
// yet confirmed, re-renders with data-submit-confirm-open="true" so the modal opens
// on connect — errors always show BEFORE the dialog. The "Yes, continue" button is a
// plain submit (carries confirmed=true), so there's no JS submit here.
export default class extends Controller {
  static targets = ['modal']

  connect() {
    if (this.element.dataset.submitConfirmOpen === 'true') this.reveal()
  }

  reveal() {
    this.modalTarget.classList.add('open', 'animate')
    document.body.classList.add('modal-open')
  }

  close(event) {
    if (event) event.preventDefault()
    this.modalTarget.classList.remove('open', 'animate')
    document.body.classList.remove('modal-open')
  }

  // Close only when the backdrop itself is clicked, not the dialog inside it.
  backdrop(event) {
    if (event.target === this.modalTarget) this.close()
  }
}
